"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformQuestionRating = void 0;
const Flag_1 = require("@opsbase/lib-issue/Flag");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const usePerformQuestionActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestionActions"));
const useAltForSelfLang_1 = __importDefault(require("@opsbase/react-ctrl-self/helpers/useAltForSelfLang"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const useForceUpdate_1 = __importDefault(require("@opsbase/react-hooks/useForceUpdate"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const range_1 = __importDefault(require("lodash/range"));
const react_1 = __importStar(require("react"));
const OpPerformQuestionCard_1 = __importDefault(require("../../OpPerformQuestionCard"));
const makeMyClasses = () => ({
    container: {
        flex: 1,
        cursor: 'pointer',
    },
    option: {
        textAlign: 'center',
        marginTop: 8,
        marginBottom: 8,
        marginLeft: -2,
        marginRight: -2,
    },
    line: {
        height: 25,
        width: 3,
        backgroundColor: lib_palette_1.default.LineGrey.main,
        alignSelf: 'flex-start',
    },
});
function OpPerformQuestionRating(props) {
    const { rule, answer } = (0, usePerformQuestion_1.default)();
    const { doChangeAnswer } = (0, usePerformQuestionActions_1.default)();
    const { forceUpdate } = (0, useForceUpdate_1.default)();
    const { mode } = (0, usePerform_1.default)();
    const viewMode = mode === 'view';
    const handleChange = (0, useCallforward_1.default)(value => () => {
        doChangeAnswer({ value });
        forceUpdate();
    }, [doChangeAnswer, forceUpdate]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(OpPerformQuestionCard_1.default, Object.assign({}, props, { disableChildren: viewMode }),
        react_1.default.createElement(Horizontal_1.default, { style: { alignItems: 'flex-end' }, padding: true }, (0, range_1.default)(5).map(idx => {
            const o = rule['rating' + idx];
            return (react_1.default.createElement(Option, { key: 'option' + idx, option: o, checked: o.value <= answer.value, color: (0, Flag_1.flagColor)(answer.flag), onClick: handleChange(o.value) }));
        })))), [answer, handleChange, props, rule, viewMode]);
}
exports.OpPerformQuestionRating = OpPerformQuestionRating;
exports.default = OpPerformQuestionRating;
function Option(props) {
    const { option, checked, onClick, color } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const label = (0, useAltForSelfLang_1.default)(option === null || option === void 0 ? void 0 : option.label, option === null || option === void 0 ? void 0 : option.labelAlt);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: myCss.container, onClick: onClick },
            react_1.default.createElement("div", { className: myCss.option },
                react_1.default.createElement("div", { style: {
                        height: 10,
                        backgroundColor: checked ? color.main : lib_palette_1.default.LineGrey.main,
                    } })),
            react_1.default.createElement(Text_1.default, { variant: "small", centered: true, style: { height: 16 } }, label || ' ')),
        react_1.default.createElement("div", { className: myCss.line }))), [checked, color, label, myCss, onClick]);
}
